<!--
 Copyright (c) 2019 ООО Код Ускорения Бизнеса - All Rights Reserved.
 Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
-->

<template>
  <div class="toast" :class="positionClass">
    <v-alert
      v-for="m in messages"
      :key="m.id"
      :value="true"
      @input="close(m.id)"
      dismissible
      :type="m.type"
      role="note"
      transition="slide-y-transition"
      @click="onClick(m)">
      {{ m.text }}
    </v-alert>
  </div>
</template>

<script>
  import { REMOVE_TOAST_MESSAGE } from './module';
  import { DefaultTransition as ToastTransition } from './config';
  import router from '@/router';

  export default {
    props: {
      position: {
        validator(value) {
          return /^(:?n|s|nw|ne|sw|se)$/.test(value);
        },
        default: 'ne',
      },

      namespace: {
        type: String,
        default: '',
      },

      html: Boolean,
    },

    computed: {
      messages() {
        return this.$store.getters[this.normalizedNamespace + 'toastMessages'];
      },

      positionClass() {
        return `toast-position-${this.position}`;
      },

      normalizedNamespace() {
        if (this.namespace === '') {
          return '';
        }

        if (!/\/$/.test(this.namespace)) {
          return this.namespace + '/';
        }

        return this.namespace;
      },
    },

    methods: {
      onClick(m) {
        if (m.url) {
          this.close(m.id);
          router.push(m.url);
        }
      },
      close(id) {
        this.$store.dispatch(this.normalizedNamespace + REMOVE_TOAST_MESSAGE, id);
      },

      messageTypeClass(message) {
        return `toast-type-${message.type}`;
      },
    },

    components: {
      ToastTransition,
    },
  };
</script>

<style lang="stylus">
  $width = 350px
  .toast
    position: fixed
    width: $width
    z-index: 100000
    /*font-family: 'Roboto', sans-serif;*/
  /**
   * Position
   */
  .toast-position-n
    top: 10px
    left: 50%
    margin-left: -($width / 2)
  .toast-position-s
    bottom: 10px
    left: 50%
    margin-left: -($width / 2)
  .toast-position-ne
    top: 10px
    right: 10px
  .toast-position-nw
    top: 10px
    left: 10px
  .toast-position-se
    bottom: 10px
    right: 10px
  .toast-position-sw
    bottom: 10px
    left: 10px
</style>
